import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ApexOptions } from 'apexcharts';

@Injectable({
    providedIn: 'root'
})
export class TotalSystemsService {

    private isBrowser: boolean;
    private chart: any | null = null;

    constructor(@Inject(PLATFORM_ID) private platformId: any) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    async loadChart(): Promise<void> {
        if (!this.isBrowser) return;

        try {
            const ApexCharts = (await import('apexcharts')).default;

            const chartElement = document.querySelector(
                '#crm_revenue_growth_chart'
            ) as HTMLElement | null;

            if (!chartElement) {
                console.warn('TotalSystemsService: element #crm_revenue_growth_chart not found');
                return;
            }

            if (this.chart) {
                this.chart.destroy();
                this.chart = null;
            }

            const options: ApexOptions = {
                series: [
                    {
                        name: 'Revenue Growth',
                        data: [211, 222, 100, 288, 166, 211, 300]
                    }
                ],
                chart: {
                    height: 120,
                    type: 'bar',
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: true
                    }
                },
                colors: ['#80CBC4'],
                plotOptions: {
                    bar: {
                        columnWidth: '45%',
                        distributed: true
                    }
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                grid: {
                    show: false,
                    strokeDashArray: 5,
                    borderColor: '#e0e0e0'
                },
                xaxis: {
                    categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
                    axisBorder: {
                        show: true,
                        color: '#e0e0e0'
                    },
                    axisTicks: {
                        show: false,
                        color: '#e0e0e0'
                    },
                    labels: {
                        show: false,
                        style: {
                            colors: '#919aa3',
                            fontSize: '14px'
                        }
                    }
                },
                yaxis: {
                    labels: {
                        show: false,
                        style: {
                            colors: '#919aa3',
                            fontSize: '14px'
                        }
                    }
                },
                tooltip: {
                    y: {
                        formatter: (val: any) => {
                            const num = Number(val);
                            return Number.isFinite(num) ? '$' + num : '';
                        }
                    }
                }
            };

            this.chart = new ApexCharts(chartElement, options);
            this.chart.render();

        } catch (error) {
            console.error('Error loading ApexCharts (TotalSystems):', error);
        }
    }

    destroyChart(): void {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
    }
}
